import React from 'react'
import _ from 'lodash'
import SettingRadioInput from './SettingRadioInput'
import Field from '../../common/FormField'

import styles from './RequiredInfo.module.css'
import settingIconDiamond from '../../../../assets/images/setting-icon-diamond.png'
import settingIconDiamondJewelry from '../../../../assets/images/setting-icon-diamond-jewelry.png'
import settingIconNonDiamondJewelry from '../../../../assets/images/setting-icon-non-diamond-jewelry.png'
import settingIconGemstone from '../../../../assets/images/setting-icon-gemstone.png'

const colors = {
  regular: [
    'd',
    'e',
    'f',
    'g',
    'h',
    'f/g/h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o-s',
    't-'
  ],
  fancy: [
    'pink',
    'orange',
    'brown',
    'yellow',
    'green',
    'red',
    'blue',
    'purple',
    'black',
    'grey',
    'champagne',
    'canary',
    'cognac',
    'salt-and-pepper'
  ]
}

const formatFancyColor = color => {
  if (color === 'salt-and-pepper') {
    return 'Salt and Pepper'
  }
  return _.capitalize(color)
}

const renderDiamondFields = (data, error, disabled, onChangeFactory) => {
  const isDiamond = data.setting === 'loose' || data.setting === 'mounted'
  const isMounted =
    data.setting === 'mounted' || data.setting === 'non-diamond-jewelry'
  const isMultipleStones = isMounted && data.mountType === 'multiple-stones'
  const carat =
    data.carat === 'not-applicable' || data.carat < 0
      ? 'Not Applicable'
      : data.carat
  const caratLabel = isMultipleStones ? 'Total Carats *' : 'Carat *'
  const caratPlaceholder = isMultipleStones
    ? 'Enter total carats (i.e. 0.75)'
    : 'Enter carat (i.e. 0.75)'
  return (
    <div>
      {!isDiamond &&
        <Field type="select" name="Gemstone *" error={error.gemstone}>
          <select
            value={data.gemstone}
            onChange={onChangeFactory('gemstone')}
            disabled={disabled}
          >
            <option value="">Select gemstone</option>
            <option value="-" disabled>
              -----
            </option>
            <option value="agate">Agate</option>
            <option value="alexandrite">Alexandrite</option>
            <option value="amazonite">Amazonite</option>
            <option value="amethyst">Amethyst</option>
            <option value="aquamarine">Aquamarine</option>
            <option value="azurite">Azurite</option>
            <option value="calcite">Calcite</option>
            <option value="citrine">Citrine</option>
            <option value="emerald">Emerald</option>
            <option value="epidote">Epidote</option>
            <option value="fluorite">Fluorite</option>
            <option value="garnet">Garnet</option>
            <option value="grape-agate">Grape Agate</option>
            <option value="grossular">Grossular</option>
            <option value="hikmanite">Hikmanite</option>
            <option value="idocrase">Idocrase</option>
            <option value="iron-stone">Iron Stone</option>
            <option value="jade">Jade</option>
            <option value="k2nite">K2nite</option>
            <option value="kunzite">Kunzite</option>
            <option value="lapis-lazuli">Lapis Lazuli</option>
            <option value="lazurite">Lazurite</option>
            <option value="mirganite">Mirganite</option>
            <option value="moonstone">Moonstone</option>
            <option value="morganite">Morganite</option>
            <option value="nephrite">Nephrite</option>
            <option value="obsidian">Obsidian</option>
            <option value="opal">Opal</option>
            <option value="pearls">Pearls</option>
            <option value="peridot">Peridot</option>
            <option value="quartz">Quartz</option>
            <option value="rare-minerals">Rare Minerals</option>
            <option value="rubellite">Rubellite</option>
            <option value="ruby">Ruby</option>
            <option value="sapphire">Sapphire</option>
            <option value="scapolite">Scapolite</option>
            <option value="spinel">Spinel</option>
            <option value="tanzanite">Tanzanite</option>
            <option value="tiger-eye">Tiger Eye</option>
            <option value="titanite">Titanite</option>
            <option value="topaz">Topaz</option>
            <option value="tourmaline">Tourmaline</option>
            <option value="turquoise">Turquoise</option>
            <option value="zircon">Zircon</option>
            <option value="not-applicable">Not Applicable</option>
          </select>
          <i />
        </Field>}
      <Field name="Color Type *">
        <div className="row">
          <div className="col col-2">
            <label className="radio">
              <input
                type="radio"
                name="colorGroup"
                value="regular"
                checked={data.colorType === 'regular'}
                onChange={onChangeFactory('colorType')}
                disabled={disabled}
              />
              <i />Regular
            </label>
          </div>
          <div className="col col-2">
            <label className="radio">
              <input
                type="radio"
                name="colorGroup"
                value="fancy"
                checked={data.colorType === 'fancy'}
                onChange={onChangeFactory('colorType')}
                disabled={disabled}
              />
              <i />Fancy
            </label>
          </div>
          {!isDiamond &&
            <div className="col col-2">
              <label className="radio">
                <input
                  type="radio"
                  name="colorGroup"
                  value="not-applicable"
                  checked={data.colorType === 'not-applicable'}
                  onChange={onChangeFactory('colorType')}
                  disabled={disabled}
                />
                <i />N/A
              </label>
            </div>}
        </div>
      </Field>
      <Field type="select" name="Shape *" error={error.shape}>
        <select
          value={data.shape}
          onChange={onChangeFactory('shape')}
          disabled={disabled}
        >
          <option value="">Select shape</option>
          <option value="round-brilliant">Round Brilliant</option>
          <option value="cushion">Cushion</option>
          <option value="asscher">Asscher</option>
          <option value="princess">Princess</option>
          <option value="pear">Pear</option>
          <option value="emerald">Emerald</option>
          <option value="marquise">Marquise</option>
          <option value="heart">Heart</option>
          <option value="oval">Oval</option>
          <option value="trilliant">Trilliant</option>
          <option value="baguette">Baguette</option>
          <option value="tapered-baguette">Tapered Baguette</option>
          <option value="radiant">Radiant</option>
          <option value="rose-cut">Rose Cut</option>
          <option value="rough">Rough</option>
          <option value="cabochon">Cabochon</option>
          <option value="mineral-specimen">Mineral Specimen</option>
          <option value="other">Other</option>
          {!isDiamond && <option value="not-applicable">Not Applicable</option>}
        </select>
        <i />
      </Field>
      <Field type="input" name={caratLabel} error={error.carat}>
        <input
          type="text"
          placeholder={caratPlaceholder}
          value={carat}
          onChange={onChangeFactory('carat')}
          disabled={disabled}
        />
      </Field>
      <Field type="select" name="Cut *" error={error.cut}>
        <select
          value={data.cut}
          onChange={onChangeFactory('cut')}
          disabled={disabled}
        >
          <option value="">Select cut</option>
          <option value="ideal">Ideal</option>
          <option value="excellent">Excellent</option>
          <option value="very-good">Very Good</option>
          <option value="good">Good</option>
          <option value="fair">Fair</option>
          <option value="poor">Poor</option>
          {!isDiamond && <option value="not-applicable">Not Applicable</option>}
        </select>
        <i />
      </Field>
      <Field type="select" name="Clarity *" error={error.clarity}>
        <select
          value={data.clarity}
          onChange={onChangeFactory('clarity')}
          disabled={disabled}
        >
          <option value="">Select clarity</option>
          <option value="f">F</option>
          <option value="if">IF</option>
          <option value="vvs1">VVS1</option>
          <option value="vvs2">VVS2</option>
          <option value="vs1">VS1</option>
          <option value="vs2">VS2</option>
          <option value="vs">VS Clarity</option>
          <option value="si1">SI1</option>
          <option value="si2">SI2</option>
          <option value="si3">SI3</option>
          <option value="si">SI Clarity</option>
          <option value="i1">I1</option>
          <option value="i2">I2</option>
          <option value="i">I Clarity</option>
          <option value="eye-clean">Eye Clean</option>
          {!isDiamond && <option value="not-applicable">Not Applicable</option>}
        </select>
        <i />
      </Field>
      <Field type="select" name="Color *" error={error.color}>
        <select
          value={data.color}
          onChange={onChangeFactory('color')}
          disabled={disabled}
        >
          <option value="">Select color</option>
          {(colors[data.colorType] || colors['regular']).map(color =>
            <option value={color} key={color}>
              {(data.colorType === 'regular' ? _.toUpper : formatFancyColor)(
                color
              )}
            </option>
          )}
          {!isDiamond && <option value="not-applicable">Not Applicable</option>}
        </select>
        <i />
      </Field>
      {data.colorType === 'fancy'
        ? <Field type="select" name="Intensity *" error={error.intensity}>
            <select
              value={data.intensity}
              onChange={onChangeFactory('intensity')}
              disabled={disabled}
            >
              <option value="">Select intensity</option>
              <option value="-" disabled>
                -----
              </option>
              <option value="natural">Natural</option>
              <option value="faint">Faint</option>
              <option value="light">Light</option>
              <option value="fancy">Fancy</option>
              <option value="intense">Intense</option>
              <option value="vivid">Vivid</option>
              <option value="deep">Deep</option>
              <option value="dark">Dark</option>
              {!isDiamond &&
                <option value="not-applicable">Not Applicable</option>}
            </select>
            <i />
          </Field>
        : null}
      {data.colorType === 'fancy'
        ? <Field type="select" name="Hue *" error={error.hue}>
            <select
              value={data.hue}
              onChange={onChangeFactory('hue')}
              disabled={disabled}
            >
              <option value="">Select hue</option>
              <option value="-" disabled>
                -----
              </option>
              <option value="even">Even</option>
              <option value="reddish">Reddish</option>
              <option value="brownish">Brownish</option>
              <option value="yellowish">Yellowish</option>
              <option value="pinkish">Pinkish</option>
              <option value="greenish">Greenish</option>
              <option value="orangish">Orangish</option>
              {!isDiamond &&
                <option value="not-applicable">Not Applicable</option>}
            </select>
            <i />
          </Field>
        : null}
      <Field type="select" name="Certificate *" error={error.certificate}>
        <select
          value={data.certificate}
          onChange={onChangeFactory('certificate')}
          disabled={disabled}
        >
          <option value="">Select certificate</option>
          <option value="gia">GIA</option>
          <option value="ags">AGS</option>
          <option value="igi">IGI</option>
          <option value="gemscan">GEMSCAN</option>
          <option value="hrd">HRD</option>
          <option value="egl">EGL</option>
          <option value="ugl">UGL</option>
          <option value="igl">IGL</option>
          <option value="gfco">GFCO</option>
          <option value="other">Other</option>
          {!isDiamond && <option value="not-applicable">Not Applicable</option>}
        </select>
        <i />
        <div className="note">
          If you don't have a certificate, select 'Other' for now.
        </div>
      </Field>
    </div>
  )
}

const renderMountedDiamondFields = (data, error, disabled, onChangeFactory) =>
  <div>
    <Field
      name={`How are the ${data.setting === 'mounted'
        ? 'diamonds'
        : 'gemstone'} presented in this item? *`}
    >
      <div className="row">
        <div className="col col-4">
          <label className="radio">
            <input
              type="radio"
              name="mountTypeGroup"
              value="center-stone"
              checked={data.mountType === 'center-stone'}
              onChange={onChangeFactory('mountType')}
              disabled={disabled}
            />
            <i />Center Stone
          </label>
        </div>
        <div className="col col-4">
          <label className="radio">
            <input
              type="radio"
              name="mountTypeGroup"
              value="multiple-stones"
              checked={data.mountType === 'multiple-stones'}
              onChange={onChangeFactory('mountType')}
              disabled={disabled}
            />
            <i />Multiple Stones
          </label>
        </div>
      </div>
    </Field>
    {data.mountType === 'center-stone'
      ? <h4>Center Stone:</h4>
      : <h4>Multiple Stones:</h4>}
    {renderDiamondFields(data, error, disabled, onChangeFactory)}
  </div>

export default ({
  data,
  error,
  disabled,
  isVerifiedSeller,
  onChangeFactory,
  onSettingChange
}) => {
  const isLoose = data.setting === 'loose' || data.setting === 'gemstone'
  return (
    <fieldset>
      <Field name="Setting *">
        <div className="note">How are you selling this item?</div>
        <div className="row">
          <div className="col">
            <SettingRadioInput
              className={styles.settingContainer}
              value="loose"
              checked={data.setting === 'loose'}
              onChange={onSettingChange}
              disabled={disabled}
            >
              <div className={styles.setting}>
                <div className={styles.settingIcon}>
                  <img src={settingIconDiamond} />
                </div>
                <div className={styles.settingText}>
                  Loose<br />Diamond
                </div>
              </div>
            </SettingRadioInput>
          </div>
          <div className="col">
            <SettingRadioInput
              className={styles.settingContainer}
              value="mounted"
              checked={data.setting === 'mounted'}
              onChange={onSettingChange}
              disabled={disabled}
            >
              <div className={styles.setting}>
                <div className={styles.settingIcon}>
                  <img src={settingIconDiamondJewelry} />
                </div>
                <div className={styles.settingText}>
                  Diamond<br />Jewelry
                </div>
              </div>
            </SettingRadioInput>
          </div>
          <div className="col">
            <SettingRadioInput
              className={styles.settingContainer}
              value="non-diamond-jewelry"
              checked={data.setting === 'non-diamond-jewelry'}
              onChange={onSettingChange}
              disabled={disabled}
            >
              <div className={styles.setting}>
                <div className={styles.settingIcon}>
                  <img src={settingIconNonDiamondJewelry} />
                </div>
                <div className={styles.settingText}>
                  Non-Diamond<br />Jewelry
                </div>
              </div>
            </SettingRadioInput>
          </div>
          <div className="col">
            <SettingRadioInput
              className={styles.settingContainer}
              value="gemstone"
              checked={data.setting === 'gemstone'}
              onChange={onSettingChange}
              disabled={disabled}
            >
              <div className={styles.setting}>
                <div className={styles.settingIcon}>
                  <img src={settingIconGemstone} />
                </div>
                <div className={styles.settingText}>
                  Loose<br />Gemstone
                </div>
              </div>
            </SettingRadioInput>
          </div>
        </div>
      </Field>
      {isLoose &&
        <Field name="Parcel Size *" error={error.parcelSize}>
          <div className="row">
            <div className="col col-4">
              <label className="radio">
                <input
                  type="radio"
                  name="parcelSizeGroup"
                  value="single"
                  checked={data.parcelSize === 'single'}
                  onChange={onChangeFactory('parcelSize')}
                  disabled={disabled}
                />
                <i />Single Stone
              </label>
            </div>
            <div className="col col-4">
              <label className="radio">
                <input
                  type="radio"
                  name="parcelSizeGroup"
                  value="multiple"
                  checked={data.parcelSize === 'multiple'}
                  onChange={onChangeFactory('parcelSize')}
                  disabled={disabled}
                />
                <i />Multiple Stones
              </label>
            </div>
          </div>
        </Field>}
      <Field
        type="toggle"
        note="Turn this option on if you would like to keep one item listing active for more than one purchase once you become a verified seller (see the &quot;Sell Online&quot; section). If you keep it off (default), then you will have to upload a new item each time you make a sale, to allow another purchase."
      >
        <input
          type="checkbox"
          checked={data.recurring}
          onChange={onChangeFactory('recurring')}
          disabled={disabled || !isVerifiedSeller}
        />
        <i data-swchon-text="ON" data-swchoff-text="OFF" />
        Allow Multiple Purchases
      </Field>
      <Field type="input" name="Title *" error={error.title}>
        <input
          type="text"
          value={data.title || ''}
          placeholder="Enter the title of the item"
          onChange={onChangeFactory('title')}
          maxLength={255}
          disabled={disabled}
        />
      </Field>
      <Field type="input" name="Price *" error={error.price}>
        <input
          type="text"
          value={data.price}
          placeholder="Enter retail price"
          onChange={onChangeFactory('price')}
          disabled={disabled}
        />
        <div className="note">
          If you want to hide the price, check the box below after entering any
          number.
        </div>
      </Field>
      <Field>
        <div className="row">
          <div className="col col-4">
            <label className="radio">
              <input
                type="radio"
                name="currencyGroup"
                value="cad"
                checked={data.currency === 'cad'}
                onChange={onChangeFactory('currency')}
                disabled={disabled}
              />
              <i />CAD (Canadian Dollar)
            </label>
          </div>
          <div className="col col-4">
            <label className="radio">
              <input
                type="radio"
                name="currencyGroup"
                value="usd"
                checked={data.currency === 'usd'}
                onChange={onChangeFactory('currency')}
                disabled={disabled}
              />
              <i />USD (US Dollar)
            </label>
          </div>
          <div className="col col-4">
            <label className="radio">
              <input
                type="radio"
                name="currencyGroup"
                value="gbp"
                checked={data.currency === 'gbp'}
                onChange={onChangeFactory('currency')}
                disabled={disabled}
              />
              <i />GBP (British Pound)
            </label>
          </div>
        </div>
      </Field>
      <Field type="checkbox">
        <input
          type="checkbox"
          checked={data.hidePrice}
          onChange={onChangeFactory('hidePrice')}
          disabled={disabled}
        />
        <i />Call for Price
      </Field>
      {isLoose
        ? renderDiamondFields(data, error, disabled, onChangeFactory)
        : renderMountedDiamondFields(data, error, disabled, onChangeFactory)}
    </fieldset>
  )
}
